import { makeStyles } from "@mui/styles"

const useStyles = makeStyles((theme) => ({
  container: {
    width: 277,
    position: "relative",
    paddingTop: 100,
    paddingLeft: 25,
    paddingRight: 16,
    boxSizing: "border-box",
  },
  iconClose: {
    fontSize: 30,
    color: "#263057",
    position: "absolute",
    top: 55,
    right: 25,
  },
  title: {
    fontFamily: "Roboto",
    fontSize: 13,
    color: "#263057",

    "&:hover": {
      fontWeight: 700,
    },
  },
  containerIcon: {
    backgroundColor: "green",
    height: 44,
    width: 44,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  containerSubIcon: {
    backgroundColor: "#fff",
    width: 44,
    borderRadius: 8,
    display: "flex",
    height: 20,
    alignItems: "center",
  },
  containerIconActive: {
    backgroundColor: "#00A88F",
    height: 80,
    width: 44,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  containerSubMenu: {
    marginLeft: 8,
    width: "30px",
  },

  icon: {
    color: "#00a78f",
    borderRadius: "8px",
    height: 20,
    paddingLeft: 1,
    // marginTop: '60px',
    "&:hover": {
      fontSize: 30,
      transform: "translateY(-2px)",
    },
  },
  iconSubItem: {
    color: "#4B4952",
    borderRadius: "8px",
    height: 20,
    paddingLeft: 1,
    // marginTop: '60px',
    "&:hover": {
      fontSize: 30,
      transform: "translateY(-2px)",
    },
  },

  mainSection: {
    display: "flex",
    alignItems: "center",
    borderRadius: 8,
  },
  linkActive: {
    display: "flex",
    alignItems: "center",
    "& #activeIcon": {
      color: "#fff",
    },
    "& #bold": {
      fontWeight: "bold",
      textDecoration: "none",
      textTransform: "none",
    },
    "& #containerIconActive": {
      backgroundColor: "#00A88F",
      height: 44,
      width: 44,
      borderRadius: 8,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  link: {
    color: "#24378F",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
  },
}))

export default useStyles
